import { Static, Array } from '@sinclair/typebox';

import { BonusProgramItem } from '../../sas-domain';

export const TravelPassFrequentFlyerProgramResponse = Array(BonusProgramItem);
export type TravelPassFrequentFlyerProgramResponse = Static<typeof TravelPassFrequentFlyerProgramResponse>;
